export default __webpack_public_path__ + "static/media/Pocketoons.ea9876d3.png";